{
  "post-office.rovo-chat-button.main-heading.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat-button.onboarding-heading": [
    {
      "type": 0,
      "value": "Chat with Rovo AI"
    }
  ],
  "post-office.rovo-chat-button.onboarding-input-placeholder-1": [
    {
      "type": 0,
      "value": "Pick a conversation starter or ask Rovo anything"
    }
  ],
  "post-office.rovo-chat-button.onboarding-input-placeholder-2": [
    {
      "type": 0,
      "value": "Write a prompt"
    }
  ],
  "post-office.rovo-chat-button.send-prompt": [
    {
      "type": 0,
      "value": "Send prompt"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.connect-button": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.heading": [
    {
      "type": 0,
      "value": "Your admin has added "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.logo-alt": [
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " logo"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.subtitle": [
    {
      "type": 0,
      "value": "Connect your account to see more results"
    }
  ],
  "post-office.rovo-chat.browse-prompt-gallery-spotlight.body": [
    {
      "type": 0,
      "value": "Explore a library of Rovo prompts you can plug into your everyday work, or create your own."
    }
  ],
  "post-office.rovo-chat.browse-prompt-gallery-spotlight.headline": [
    {
      "type": 0,
      "value": "Browse prompt library"
    }
  ],
  "post-office.rovo-chat.memory-settings-onboarding-spotlight.action": [
    {
      "type": 0,
      "value": "See how"
    }
  ],
  "post-office.rovo-chat.memory-settings-onboarding-spotlight.body": [
    {
      "type": 0,
      "value": "Rovo now remembers facts and details from your chats to make responses more personalized and helpful"
    }
  ],
  "post-office.rovo-chat.memory-settings-onboarding-spotlight.headline": [
    {
      "type": 0,
      "value": "A more personalized Rovo"
    }
  ],
  "post-office.rovo-chat.think-deeper-spotlight.body": [
    {
      "type": 0,
      "value": "Turn on Think Deeper for deeper, more nuanced answers to complex questions."
    }
  ],
  "post-office.rovo-chat.think-deeper-spotlight.dismiss": [
    {
      "type": 0,
      "value": "Turn on Think Deeper"
    }
  ],
  "post-office.rovo-chat.think-deeper-spotlight.headline": [
    {
      "type": 0,
      "value": "Let Rovo think it through"
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.body": [
    {
      "type": 0,
      "value": "We're running an experiment to improve Rovo. For some users, web search is now on by default—you can turn it off any time."
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.dismiss": [
    {
      "type": 0,
      "value": "Turn off default web search"
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.headline": [
    {
      "type": 0,
      "value": "Web search is now on by default"
    }
  ],
  "rovo-chat.rovo-chat-scheduled-chat-recurring-chat-complete.message-template.notification-drawer.message.no-translate": [
    {
      "type": 0,
      "value": "Rovo has completed your scheduled query"
    }
  ]
}